import React from "react";

import Card from "@busbud/design-system-components/dist/Card/Card";
import CardHeader from "@busbud/design-system-components/dist/CardHeader/CardHeader";
import IconButton from "@busbud/design-system-components/dist/IconButton/IconButton";
import MinusMD from "@busbud/design-system-components/dist/Icons/Minus/MD";
import PlusMD from "@busbud/design-system-components/dist/Icons/Plus/MD";
import Label from "@busbud/design-system-components/dist/Label/Label";
import Skeleton from "@busbud/design-system-components/dist/Skeleton/Skeleton";

import { MAX_PASSENGERS_NUMBER } from "@app/constants/passengers";
import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./passenger-selector.styles";
import {
  usePassengerStore,
  removePassenger,
  addPassenger
} from "./passenger-store";

type ButtonProps = {
  disabled?: boolean;
  action: "increment" | "decrement";
  onClick: () => void;
};

export const ActionButton: React.FC<ButtonProps> = React.memo(
  ({ onClick, disabled, action, ...others }) => (
    <IconButton
      {...others}
      onClick={onClick}
      disabled={disabled}
      color="secondary"
      size="sm"
    >
      {action === "decrement" ? <MinusMD /> : <PlusMD />}
    </IconButton>
  )
);
interface PassengerSelectorProps {
  is_loading: boolean;
}

export const PassengerSelector: React.FC<PassengerSelectorProps> = ({
  is_loading
}) => {
  const { classes } = useStyles();
  const { selected_seats_count } = usePassengerStore();
  const { translator } = useAppContext();

  if (is_loading) {
    return <PassengerSelectorSkeleton />;
  }

  return (
    <Card boxShadow="unset" borderRadius="xl">
      <CardHeader title={translator.t("!passengers-on-this-trip")}>
        <ActionButton
          disabled={selected_seats_count <= 1}
          onClick={removePassenger}
          action="decrement"
        />
        <Label size="lg" fontWeight="bold" className={classes.counter}>
          {selected_seats_count}
        </Label>
        <ActionButton
          disabled={selected_seats_count === MAX_PASSENGERS_NUMBER}
          onClick={addPassenger}
          action="increment"
        />
      </CardHeader>
    </Card>
  );
};

const PassengerSelectorSkeleton = () => {
  return (
    <Card boxShadow="unset" borderRadius="xl">
      <CardHeader title={<Skeleton width={20} size="lg" />}>
        <Skeleton width={13} size="lg" />
      </CardHeader>
    </Card>
  );
};
